module.exports = __webpack_public_path__ + "static/img/wireframe-2.092d0082.jpg";